@if (show()) {
  <div (click)="close()" [@fadeAnimation] class="sidepanelBg"></div>
  <div [@slideInOut] [ngStyle]="{'width': width ? width+'px' : ''}" class="sidebar-container overflow-hidden">
    <div class="card tw-h-full">
      <div class="card-header">
        <div>
          <ng-container *ngTemplateOutlet="sidebarHeader"></ng-container>
        </div>
        <div class="header-more">
          <button (click)="close()" class="btn btn-hover-primary">
            <sb-icon icon="cancel"></sb-icon>
          </button>
        </div>
      </div>
      <div class="card-body tw-overflow-y-auto"
           [ngClass]="{'tw-pb-[100px]': !sidebarFooter}">
        <div class="">
          <ng-container *ngTemplateOutlet=sidebarTemplate></ng-container>
        </div>
      </div>
      @if (sidebarFooter) {
        <div class="card-footer tw-pt-6" style="padding-bottom: 100px;">
          <ng-container *ngTemplateOutlet="sidebarFooter"></ng-container>
        </div>
      }
    </div>
  </div>
}
